// extracted by mini-css-extract-plugin
export default {"iconContainer":"beachLineFeature-module__iconContainer__3NsS6"};